export const conceptsContent = {
  headline: [
    { text: 'камерный', indent: 0, opacity: 1 },
    { text: 'квартал,', indent: 5, opacity: 1 },
    { text: 'в котором', indent: 2, opacity: 1 },
    { text: 'архитектура', indent: 4, opacity: 0.6 },
    {
      indent: 6,
      parts: [
        { text: 'соразмерна ', opacity: 0.6 },
        { text: 'человеку', opacity: 1, emphasis: true },
      ],
    },
  ],
  centerLines: [
    { text: 'сдача 2-й очереди —', opacity: 1 },
    { text: 'IV квартал 2026 года', opacity: 0.6 },
  ],
  slides: [
    {
      lines: [
        { text: '«Причал» — это', opacity: 1 },
        { text: 'самодостаточный кластер на 12,69 га.', opacity: 1 },
        { text: 'мы отказались от высотной застройки', opacity: 0.6 },
        { text: 'в пользу 4-этажных секций', opacity: 0.6 },
      ],
    },
    {
      lines: [
        { text: 'такая высота позволяет сохранить визуальную связь с лесом и небом,', opacity: 1 },
        { text: 'создавая ощущение загородного дома с сервисом бизнес-класса', opacity: 0.6 },
      ],
    },
    {
      lines: [
        { text: 'дом формирует приватное пространство.', opacity: 1 },
        { text: 'такое решение создает внутри уютный двор, полностью укрытый от посторонних взглядов', opacity: 0.6 },
      ],
    },
  ],
};
